import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class ParametroEmpresaService {
  constructor(private gqlclient: GraphQLClient) {}

  obtenerIVA(rut_empresa: number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            parametro_empresa {
              obtenerIVA(entidad: { empresa_rut: $empresa_rut }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  valor_numerico
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rut_empresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.parametro_empresa.obtenerIVA.mensajes,
          respuesta: response.data.parametro_empresa.obtenerIVA.respuesta,
        });
      }
    );
  }

  permiteUnidadNegocio(rut_empresa: number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            parametro_empresa {
              permiteUnidadNegocio(entidad: { empresa_rut: $empresa_rut }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  valor_bool
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rut_empresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.parametro_empresa.permiteUnidadNegocio.mensajes,
          respuesta: response.data.parametro_empresa.permiteUnidadNegocio.respuesta,
        });
      }
    );
  }

  permiteRealizarSeguimiento(rut_empresa: number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            parametro_empresa {
              permiteRealizarSeguimiento(entidad: { empresa_rut: $empresa_rut }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  valor_bool
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rut_empresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.parametro_empresa.permiteRealizarSeguimiento.mensajes,
          respuesta: response.data.parametro_empresa.permiteRealizarSeguimiento.respuesta,
        });
      }
    );
  }

  permiteVisualizarDescuentoTope(rut_empresa: number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            parametro_empresa {
              permiteVisualizarDescuentoTope(entidad: { empresa_rut: $empresa_rut }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  valor_bool
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rut_empresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.parametro_empresa.permiteVisualizarDescuentoTope.mensajes,
          respuesta: response.data.parametro_empresa.permiteVisualizarDescuentoTope.respuesta,
        });
      }
    );
  }

  permiteVisualizarMixtura(rut_empresa: number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            parametro_empresa {
              permiteVisualizarMixtura(entidad: { empresa_rut: $empresa_rut }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  valor_bool
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rut_empresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.parametro_empresa.permiteVisualizarMixtura.mensajes,
          respuesta: response.data.parametro_empresa.permiteVisualizarMixtura.respuesta,
        });
      }
    );
  }

  obtenerMontoSencillo(rut_empresa: Number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            parametro_empresa {
              obtenerMontoSencillo(entidad: { empresa_rut: $empresa_rut }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  valor_numerico
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rut_empresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.parametro_empresa.obtenerMontoSencillo.mensajes,
          respuesta: response.data.parametro_empresa.obtenerMontoSencillo.respuesta,
        });
      }
    );
  }

  obtenerUrlNegociador(rut_empresa: Number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            parametro_empresa {
              obtenerUrlNegociador(entidad: { empresa_rut: $empresa_rut }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  valor
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rut_empresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.parametro_empresa.obtenerUrlNegociador.mensajes,
          respuesta: response.data.parametro_empresa.obtenerUrlNegociador.respuesta,
        });
      }
    );
  }

  obtenerUrlMensaje(rut_empresa: Number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            parametro_empresa {
              obtenerUrlMensaje(entidad: { empresa_rut: $empresa_rut }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  valor
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rut_empresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.parametro_empresa.obtenerUrlMensaje.mensajes,
          respuesta: response.data.parametro_empresa.obtenerUrlMensaje.respuesta,
        });
      }
    );
  }

  obtenerUrlDescagarBlob(rut_empresa: Number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal) {
            parametro_empresa {
              obtenerUrlDescagarBlob(entidad: { empresa_rut: $empresa_rut }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  valor
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: rut_empresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        callback({
          mensajes: response.data.parametro_empresa.obtenerUrlDescagarBlob.mensajes,
          respuesta: response.data.parametro_empresa.obtenerUrlDescagarBlob.respuesta,
        });
      }
    );
  }
}
